import { Icon, Text } from '@tectonicfi/tectonic-ui-kit';

import { VENO_FINANCE_URL } from '@config/base';

export default function Description() {
  return (
    <>
      <div className="pt-3 text-mediumSmall leading-[21px] text-white60">
        The Veno pool allows users to exclusively deposit or borrow between the
        tokens listed below. For example, a user could deposit USDC and borrow
        LCRO to provide liquidity to the LCRO-CRO pool on{' '}
        <a
          href="https://ferroprotocol.com/#/pools"
          rel="noopener noreferrer"
          target="_blank"
          className="text-yellow"
        >
          Ferro Protocol.
        </a>{' '}
        Find out more about isolated pools&nbsp;
        <a
          href="https://tectonic.gitbook.io/docs/protocol/isolated-pools"
          rel="noopener noreferrer"
          target="_blank"
          className="text-yellow"
        >
          here
        </a>
      </div>
      <div className="my-4 flex items-center gap-1">
        <Text className="text-large">In partnership with:</Text>
        <a href={VENO_FINANCE_URL} rel="noopener noreferrer" target="_blank">
          <Icon.VenoLink width={128} height={24} />
        </a>
      </div>
    </>
  );
}
